import { useCallback, useState } from 'react'

export const useImageToBase64 = () => {
  const [image, setImage] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const loadImage = useCallback(async (url: string) => {
    setLoading(true)
    setError(null)

    try {
      const image = await imageUrlToBase64(url)
      if (image) setImage(image)
    } catch (e) {
      const err = e as Error
      setError(
        `Failed to load base64 image: ${url} = ${
          err.message || 'Unknown error'
        }`
      )
    } finally {
      setLoading(false)
    }
  }, [])

  return { image, loadImage, loading, error }
}

export const imageUrlToBase64 = async (image: string): Promise<string> => {
  const response = await fetch(image)
  if (!response.ok) {
    throw new Error(`Failed to fetch image: ${response.statusText}`)
  }
  const blob = await response.blob()

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      if (reader.result) {
        resolve(reader.result as string)
      } else {
        reject(new Error('Failed to convert blob to Base64.'))
      }
    }
    reader.onerror = () => reject(new Error('FileReader encountered an error.'))
    reader.readAsDataURL(blob)
  })
}
